import { render, staticRenderFns } from "./batchDownload.vue?vue&type=template&id=bbb3d910&scoped=true"
import script from "./batchDownload.vue?vue&type=script&lang=js"
export * from "./batchDownload.vue?vue&type=script&lang=js"
import style0 from "./batchDownload.vue?vue&type=style&index=0&id=bbb3d910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb3d910",
  null
  
)

export default component.exports